import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import SmsEnvio from '../../../models/SmsEnvio';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:            { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    destino:       { exibir: 'main.smsenvio.destino', visivel: true, keyfilter: 'num', icone: 'pi-phone', validacao: { obrigatorio: true, telefonecomddd: true } },
    mensagem:      { exibir: 'main.smsenvio.mensagem', visivel: true, linhas: 4, validacao: { obrigatorio: true } },
    dataenvio:     { exibir: 'main.smsenvio.dataenvio', visivel: true, tipo: 'date', time: true },
    ultimoretorno: { exibir: 'main.smsenvio.ultimoretorno', linhas: 18 },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

// dataenvio/ultimoretorno são preenchidos automaticamente pelo backend (afterCreate/afterUpdate
// de SmsEnvio) assim que o envio é processado — não editáveis pelo admin de um tenant de
// cliente. A publicação master pode editar/limpar dataenvio pra forçar reprocessamento de um
// envio que falhou (mesmo reforço replicado no backend, ver SmsEnvioController.update).
// ultimoretorno fica numa aba própria: no grid junto dos outros campos, o textarea não tinha
// espaço vertical suficiente para rolar um retorno mais longo.
class SmsEnvioFormulario extends Component {
    render() {
        const { model, contexto, permissoes } = this.props;
        const podeEditarDataEnvio = !!permissoes?.permiteacessogeral;
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.smsenvio.aba.dados')} leftIcon="pi pi-send mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.destino} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelCalendar model={{ ...model.dataenvio, disabled: !podeEditarDataEnvio }} contexto={contexto} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={model.mensagem} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.smsenvio.aba.retorno')} leftIcon="pi pi-list mr-2">
                    <div className="grid">
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={{ ...model.ultimoretorno, disabled: true }} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class SmsEnvioTemplate extends Component {
    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={SmsEnvio}
                model={model}
                identidade="main.smsenvio"
                permissoes={this.props.permissoes}
                icone="pi-send"
                storageKey="dt-smsenvios"
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <SmsEnvioFormulario model={m} contexto={ctx} permissoes={this.props.permissoes} />}
            />
        );
    }
}

export default SmsEnvioTemplate;
